var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1695_6384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.94317 0 0 4.94351 0 11C0 17.0568 4.94351 22 11 22C17.0568 22 22 17.0564 22 11C22 4.94317 17.0565 0 11 0ZM11 20.7109C5.64536 20.7109 1.28906 16.3546 1.28906 11C1.28906 5.64536 5.64536 1.28906 11 1.28906C16.3546 1.28906 20.7109 5.64536 20.7109 11C20.7109 16.3546 16.3546 20.7109 11 20.7109Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53125 17.1133C5.88721 17.1133 6.17578 16.8247 6.17578 16.4688C6.17578 16.1128 5.88721 15.8242 5.53125 15.8242C5.17528 15.8242 4.88672 16.1128 4.88672 16.4688C4.88672 16.8247 5.17528 17.1133 5.53125 17.1133Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4688 6.17578C16.8247 6.17578 17.1133 5.88721 17.1133 5.53125C17.1133 5.17528 16.8247 4.88672 16.4688 4.88672C16.1128 4.88672 15.8242 5.17528 15.8242 5.53125C15.8242 5.88721 16.1128 6.17578 16.4688 6.17578Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0755 5.0755C4.82379 5.32721 4.82379 5.73529 5.0755 5.987C5.32721 6.23871 5.73529 6.23871 5.987 5.987C6.23871 5.73529 6.23871 5.32721 5.987 5.0755C5.73533 4.82379 5.32721 4.82379 5.0755 5.0755Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.013 16.013C15.7613 16.2647 15.7613 16.6728 16.013 16.9245C16.2647 17.1762 16.6728 17.1762 16.9245 16.9245C17.1762 16.6728 17.1762 16.2647 16.9245 16.013C16.6728 15.7613 16.2647 15.7613 16.013 16.013Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.19922C11.356 5.19922 11.6445 4.91064 11.6445 4.55469V3.26562C11.6445 2.90967 11.356 2.62109 11 2.62109C10.644 2.62109 10.3555 2.90967 10.3555 3.26562V4.55469C10.3555 4.91064 10.644 5.19922 11 5.19922Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.8008C10.644 16.8008 10.3555 17.0894 10.3555 17.4453V18.7344C10.3555 19.0903 10.644 19.3789 11 19.3789C11.356 19.3789 11.6445 19.0903 11.6445 18.7344V17.4453C11.6445 17.0894 11.356 16.8008 11 16.8008Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 11C5.19922 10.644 4.91064 10.3555 4.55469 10.3555H3.26562C2.90967 10.3555 2.62109 10.644 2.62109 11C2.62109 11.356 2.90967 11.6445 3.26562 11.6445H4.55469C4.91064 11.6445 5.19922 11.356 5.19922 11Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 11C16.8008 11.356 17.0894 11.6445 17.4453 11.6445H18.7344C19.0903 11.6445 19.3789 11.356 19.3789 11C19.3789 10.644 19.0903 10.3555 18.7344 10.3555H17.4453C17.0894 10.3555 16.8008 10.644 16.8008 11Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6445 10.733V7.13281C11.6445 6.77686 11.356 6.48828 11 6.48828C10.644 6.48828 10.3555 6.77686 10.3555 7.13281V11C10.3555 11.1709 10.4234 11.3349 10.5443 11.4558L14.4115 15.323C14.6631 15.5746 15.0712 15.5747 15.323 15.323C15.5747 15.0712 15.5747 14.6632 15.323 14.4115L11.6445 10.733Z",
    fill: "#FF5C5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_6384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockImg);
export default __webpack_public_path__ + "static/media/clockImg.c3fd1e096c8bb84110fab8b9753b2482.svg";
export { ForwardRef as ReactComponent };